export function getCurrentPosition(options = {}) {
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
    });
}

export async function fetchCoordinates(){
    try {
        const { coords } = await getCurrentPosition();
        //const { latitude, longitude } = coords;
        return coords;
        // Handle coordinates
    } catch (error) {
        // Handle error
        console.error(error);
    }
};